// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yHD6Wjjykt8HU5utwlHk{padding:8px}.yHD6Wjjykt8HU5utwlHk:before{left:0;right:0}.jYCI5rOYs9MYWETOIUnO:before{top:calc(100% + 6px)}.aQ7o0xmLFlccfrsYCEZC,.wbs0E9HpPEU9MJdp1Fqd{padding:12px}.wbs0E9HpPEU9MJdp1Fqd{text-align:center}._6z4G_79PSMj6eDWPXKy{cursor:pointer;border-radius:6px;justify-content:space-between;align-items:center;gap:8px;padding:8px 12px;display:flex}._6z4G_79PSMj6eDWPXKy:hover{background:var(--background-neutral-subtle)}.W2XXV_Srfg80XK1I80Iw{flex:1;align-items:center;gap:8px;min-width:0;display:flex}.Ibhyhj7w3IV3DSqvH6qV{max-height:208px;padding:4px 0 4px 4px;overflow-y:auto}.Nk9YSc7RN0NZLyIFo8dd{flex-shrink:0}.b0UQSg12sJMVhZoAOx6k{min-width:0;color:var(--content-primary-primary)}.Pfd6iO17zrwqkmkfXOA1{flex-shrink:0;max-width:240px}.Wt7NOW5WJc4NcaKuqwzA{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `yHD6Wjjykt8HU5utwlHk`,
	"tab": `jYCI5rOYs9MYWETOIUnO`,
	"dropdownMinChars": `aQ7o0xmLFlccfrsYCEZC`,
	"dropdownEmpty": `wbs0E9HpPEU9MJdp1Fqd`,
	"contactItem": `_6z4G_79PSMj6eDWPXKy`,
	"dropdownLabel": `W2XXV_Srfg80XK1I80Iw`,
	"dropdownOptions": `Ibhyhj7w3IV3DSqvH6qV`,
	"dropdownAvatar": `Nk9YSc7RN0NZLyIFo8dd`,
	"dropdownName": `b0UQSg12sJMVhZoAOx6k`,
	"dropdownEmail": `Pfd6iO17zrwqkmkfXOA1`,
	"searchIcon": `Wt7NOW5WJc4NcaKuqwzA`
};
export default ___CSS_LOADER_EXPORT___;
